import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement('select-field-option')
export class SelectFieldOption extends LitElement {
    @property()
    text = '';

    @property()
    value = '';

    @property({reflect: true, type: Boolean})
    disabled = false;

    @property({type: Boolean})
    selected = false;

    override updated() {
        this.dispatchEvent(new CustomEvent('select-field:optionChanged', {
            bubbles: true,
            detail: { text: this.text, value: this.value, disabled: this.disabled, selected: this.selected }
        }));
    }
}


declare global {
    interface HTMLElementTagNameMap {
        "select-field-option": SelectFieldOption,
    }
}
